var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"wrapper"}},[_c('navbar'),_vm._v(" "),_c('div',{staticClass:"wl-illustrated-errors-page"},[_c('child')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }